const { loadScripts } = Mobi2Go.helpers;

const TURNSTILE_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

export async function turnstileWidgetRemove (widget_element_id) {
    window.turnstile.remove('#' + widget_element_id)
};

export async function turnstileWidgetRender (site_key, widget_element_id, render_params) {
    if (!window.turnstile) {
        await loadScripts([TURNSTILE_URL], true);
    }

    render_params = render_params || {};

    return new Promise((resolve, reject) => {
        window.turnstile.render('#' + widget_element_id, {
            ...render_params,
            "sitekey": site_key,
            "callback": (response) => resolve(response),
            "timeout-callback": () => reject("Timeout error"),
            "error-callback": () => reject("Network error"),
            "expired-callback": () => reject("Challenge expired")
        })
    });
};

export async function turnstileGlobalFetch (site_key, action) {
    const widget_element_id = "cloudflare-turnstile-widget-root";
    const widget_element = window.document.createElement("div");
    widget_element.setAttribute("id", widget_element_id);

    window.document.body.appendChild(widget_element);

    const response = await turnstileWidgetRender(site_key, widget_element_id, {
        /* A customer value that can be used to differentiate widgets
        under the same sitekey in analytics and which is returned upon validation.
        This can only contain up to 32 alphanumeric characters including _ and -. */
        action: action ?? 'unspecified',

        /* Execution controls when to obtain the token of the widget
        and can be on render (default) or on execute.
        Refer to Execution Modes (docs) for more information. */
        execution: 'render',
    });

    await turnstileWidgetRemove(widget_element_id);

    return response;
}